import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateEventAddressService, type UpdateAddressPayload } from '@/services/events'
import { eventDetailsQueryKey } from './useEventDetails'

export const useUpdateEventAddress = (agendaId: string, eventId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: UpdateAddressPayload) =>
      updateEventAddressService(agendaId, eventId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: eventDetailsQueryKey(agendaId, eventId) })
      queryClient.invalidateQueries({ queryKey: ['calendar'] })
    },
  })
}
